import React, { Component } from 'react';
import { Row, Col, Card, Button, Popconfirm, Spin, PageHeader, Layout, message, Space, List, Typography, Collapse, Dropdown, Menu, Upload, Switch, InputNumber, Tag, Popover, Empty } from 'antd'
import axios from 'axios';
import { Link, useNavigate } from "react-router-dom";
import { BsFillFlagFill, BsCheckLg } from 'react-icons/bs';
import InfiniteScroll from "react-infinite-scroll-component";
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';


//Modales
import ModalProductoProveedor from "./ModalProductoProveedor"

//Componentes
import CustomAvatar from '../../../Widgets/Avatar/Avatar';
import FormRequisicionOpcion from "./FormRequisicionOpcion"
import { IconCheckBtn, IconCheckMedalColor, IconPlusGroup, IconFlag } from '../../../Widgets/Iconos'






const { Text } = Typography;
const moment = require('moment')

const { Content } = Layout;
const { Panel } = Collapse;


let colors_flag = {
    0: '#5151ec',
    1: '#ecea51',
    2: '#ec5151',
}

/**
 * @export
 * @class ListaRequerido
 * @extends {Component}
 * @description Vista de ListaRequerido
 */
export default class ListaRequerido extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            requisiciones:{
                data: [],
                page: 1,
                limit: 20,
                total: 0,

                called: false,
            },
            requisicion_id: undefined,
            modal_visible: false,

        }
    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');

        this.getRequisiciones()
    }

    componentDidUpdate(prevProps) {
        if(prevProps.search != this.props.search)
            this.getRequisiciones({page: 1})
    }

    /**
     * @methodOf ListaRequerido
     * @function getRequisiciones
     * @description Otiene el listado de requeridos
     */
    getRequisiciones = ({
        page = this.state.requisiciones.page,
        limit = this.state.requisiciones.limit,
        search = this.props.search,
    } = this.state.requisiciones) => {

        this.setState({loading: true})
        axios.get("/requisiciones",{
            params:{
                page,
                limit,
                search,
                estatus: 1
            }
        }).then(({data}) => {
            let requisiciones = page === 1 ? [] : [...this.state.requisiciones.data]

            this.setState({
                requisiciones: {
                    data: requisiciones.concat(data.data),
                    page: data.page,
                    total: data.total,
                    limit: data.limit,
                    called: true
                },
                hasMore: requisiciones.concat(data.data).length < data.total
            })

        }).catch(error => {
            console.log("error", error);
            message.error(error?.response?.data?.message ?? "Error al obtener las requisiciones")

        }).finally(()=>this.setState({loading: false}))

    }

    next = () => {
        if(this.state.requisiciones.data.length < this.state.requisiciones.total && this.state.loading === false){
            return this.getRequisiciones({page: this.state.requisiciones.page + 1})
        }
    }


    /**
     * @methodOf ListaRequerido
     * @function updateRequisicionOpcion
     * @description Actualiza la informacion de una requisiscion opcion
     */
    updateRequisicionOpcion = (values) => {
        axios.put('/requisicion-opcion',{
            ...values
        }).then(response => {
            console.log("Actualizado")
        }).catch(error => {
            console.log("No Actualizado ")
        })
    }


    /***
     *
     * @methodOf ListaRequerido
     * @function activate
     * @description Actualiza el marcador de activacion de la requisicion
     * 
     * @params requisicion_id id de la requisisicion a actualizar
     */
    activate = (requisicion_id, index) => {
        axios.put('/requisiciones',{
            requisicion_id,
            activado: true
        }).then(response => {
            let data = this.state.requisiciones.data
            data[index].activado = response.data.activado
            data[index].fecha_autorizacion = response.data.fecha_autorizacion
            this.setState({
                requisiciones:{
                    ...this.state.requisiciones,
                    data
                }
            })
        }).catch(error => {
            message.error(error?.response?.data?.message ?? "Error al actualizar")
        })
    }


    /***
     *
     * @methodOf ListaRequerido
     * @function addOpcion
     * @description Al añadir una requisicion_opcion, la agrega al array de las opciones
     */
    addOpcion = (requisicion_opcion) => {
        let data = this.state.requisiciones.data;

        if(this.state.index_requisicion >= 0){
            data[this.state.index_requisicion].opciones.push(requisicion_opcion)

            this.setState({
                requisiciones:{
                    ...this.state.requisiciones,
                    data,
                },
                modal_visible: false, 
                requisicion_id: undefined, 
                index_requisicion: undefined
            })
        }
    }

    /***
     *
     * @methodOf ListaRequerido
     * @function aceptarOpcion
     * @description Acepta una requisicion_opcion y actualiza el estatus de la requisicion
     */
    aceptarOpcion = ({requisicion_opcion_id}) => {
        this.setState({loading: true})
        axios.post('/requisicion-opcion/aceptar',{
            requisicion_opcion_id
        }).then(response => {
            this.props.getRequisiciones([1,2])
        }).catch(error=>{
            console.log("error", error);
            message.error(error?.response?.data?.message ?? "Error al aceptar al proveedor")
        }).finally(()=>{
            this.setState({loading: false})
        })
    }


    /***
     *
     * @methodOf ListaRequerido
     * @function deleteOpcion
     * @description Elimina una de las opciones de una requisicion y la quita del state para no llamar al metodo get
     */
    deleteOpcion = (requisicion_opcion_id, index) => {
        this.setState({loading: true})
        axios.delete('/requisicion-opcion',{
            params:{
                id: requisicion_opcion_id
            }
        }).then(response => {
            message.success("Eliminado")

            let requisiciones = {...this.state.requisiciones}

            let index_op = requisiciones.data[index].opciones.findIndex(e =>  e._id.toString() === requisicion_opcion_id.toString()) 
            if(index !== -1){
                requisiciones.data[index].opciones.splice(index_op,1)
                this.setState({
                    requisiciones
                })
            }
        }).catch(error => {
            console.log("error", error);
            message.error(error?.response?.data?.message ?? "Error al eliminar")
        }).finally(()=>this.setState({loading: false}))
    }

    /***
     *
     * @methodOf ListaRequerido
     * @function deleteRequisicion
     * @description Elimina una requisicion y la quita del state para no llamar al metodo get
     */
    deleteRequisicion = (requisicion_id,) => {
        this.setState({loading: true})
        axios.delete('/requisiciones',{
            params:{
                id: requisicion_id
            }
        }).then(response => {
            message.success("Eliminado")

            let requisiciones = {...this.state.requisiciones}

            let index = requisiciones.data.findIndex(e => e._id.toString() === requisicion_id.toString())
            if(index !== -1){
                requisiciones.data.splice(index,1)
                this.setState({
                    requisiciones
                })
            }
        }).catch(error => {
            console.log("error", error);
            message.error(error?.response?.data?.message ?? "Error al eliminar")
        }).finally(()=>this.setState({loading: false}))
    }



    render() {

        let { label, name } = this.props

        return (
            <>
                <Collapse
                    bordered={false}
                    className="mb-1 w-100"
                    defaultActiveKey={['1']}
                >
                    <Panel
                        header={'Requerido'}
                        className={`requisiciones-tab tab-requerido`}
                        key="1"
                    >
                        { this.state.requisiciones.data.length > 0 ? <InfiniteScroll
                            dataLength={this.state.requisiciones.data.length}
                            next={this.next}
                            hasMore={this.state.hasMore}
                            loader={<Spin tip="Cargando..."><h4 style={{height: '100px'}}></h4></Spin>}
                            height={550}
                            className="mb-2"
                        >
                            <List
                                loading={this.state.loading}
                                className="component-list"
                                itemLayout="horizontal"
                                locale={{ emptyText: this.state.loading ? "Cargando" : "Sin Requisiciones" }}
                                dataSource={this.state.requisiciones.data}
                                renderItem={({_id, producto_id, proyecto_id, volumen, prioridad, opciones, categoria_id, activado, unidad_id, createdAt, inmuebles, fecha_autorizacion}, index) => (
                                    <List.Item className="component-list-item" key={_id}>
                                        <Collapse className='width-100'>
                                            <Panel
                                                header={
                                                    <Row className="width-100 " gutter={[0, 12]}>
                                                        <Col xs={24} md={5} className="center" >
                                                            <Text ellipsis>{producto_id?.nombre}</Text>
                                                        </Col>
                                                        <Col xs={24} md={3} className="center" >
                                                            <Text ellipsis >{categoria_id.nombre}</Text>
                                                        </Col>
                                                        <Col xs={24} md={3} className="center" >
                                                            <Text ellipsis >{volumen?.toMoney(true)} {unidad_id?.nombre}</Text>
                                                        </Col>
                                                        <Col xs={24} md={3} className="center" >
                                                            <Popover 
                                                                content={inmuebles?.map(e=><><Text>{e.nombre}</Text><br/></>)} 
                                                            >
                                                                <Text ellipsis>{inmuebles?.map(e=><Tag color="lime">{e.nombre}</Tag>)}</Text>
                                                            </Popover>
                                                        </Col>
                                                        <Col xs={24} md={4} className="center" >
                                                            <CustomAvatar 
                                                                name={proyecto_id.nombre}
                                                                color={proyecto_id.color}
                                                                url={{
                                                                    url:`${axios.defaults.baseURL}/proyectos/logo/${proyecto_id?._id}`,
                                                                    name: proyecto_id?.logo?.name
                                                                }}
                                                            />
                                                            <Text>{proyecto_id.nombre}</Text>
                                                        </Col>
                                                        <Col xs={24} md={1} className="center" >
                                                            <IconFlag fill={colors_flag[prioridad] ? colors_flag[prioridad] : '#A4A4A4'} />
                                                        </Col>
                                                        <Col xs={24} md={2} className="center" >
                                                            <Text ellipsis >{ fecha_autorizacion ? moment(fecha_autorizacion).format("YYYY-MM-DD") : activado ? moment(createdAt).format("YYYY-MM-DD")  : "-" }</Text>
                                                        </Col>
                                                        <Col xs={24} md={1} className="center">
                                                            <Button
                                                                className={`btn-permission ${activado ? 'active' : ''}`}
                                                                type="ghost"
                                                                icon={<IconCheckMedalColor/>}
                                                                onClick={(e)=>{
                                                                    e.stopPropagation()
                                                                    this.activate(_id, index)
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col xs={24} md={2} className="center">
                                                            <Space>
                                                                <Popconfirm
                                                                    placement="topRight"
                                                                    title="¿Deseas eliminar esta requisición?"
                                                                    onConfirm={() => this.deleteRequisicion(_id)}
                                                                    okText="Si"
                                                                    cancelText="No"
                                                                >
                                                                    <Button 
                                                                        className="center" 
                                                                        type="danger" 
                                                                        icon={<DeleteOutlined />}
                                                                        onClick={(e)=>{e.stopPropagation()}}
                                                                    />
                                                                </Popconfirm>
                                                                <Button 
                                                                    type="primary" 
                                                                    className="center" 
                                                                    icon={<IconPlusGroup />} 
                                                                    title="Añadir Proveedor"
                                                                    onClick={(e)=>{
                                                                        e.stopPropagation()
                                                                        this.setState({modal_visible: true, requisicion_id: _id, index_requisicion:index}) 
                                                                    }} 
                                                                />
                                                            </Space>
                                                        </Col>
                                                    </Row>
                                                }
                                                key={_id}
                                                className={`requisiciones-item-requerido`}
                                            >
                                                <List
                                                    className='component-list'
                                                    itemLayout="horizontal"
                                                    locale={{ emptyText: "Sin proveedores" }}
                                                    dataSource={opciones}
                                                    header={
                                                        <Row className="width-100 ">
                                                            <Col span={5} className="center" >
                                                                <Text className="text-gray" ellipsis>Proveedor</Text>
                                                            </Col>
                                                            <Col span={4} className="center" >
                                                                <Text className="text-gray" ellipsis >Precio Unitario</Text>
                                                            </Col>
                                                            <Col span={3} className="center" >
                                                                <Text className="text-gray" ellipsis >Dias de entrega</Text>
                                                            </Col>
                                                            <Col span={3} className="center" >
                                                                <Text className="text-gray" ellipsis >Costo envio</Text>
                                                            </Col>
                                                            <Col span={4} className="center" >
                                                                <Text className="text-gray" ellipsis >Monto Total</Text>
                                                            </Col>
                                                            <Col span={3} className="center" >
                                                                <Text className="text-gray" ellipsis >Archivos</Text>
                                                            </Col>
                                                        </Row>
                                                    }
                                                    renderItem={item => (
                                                        <List.Item>
                                                            <FormRequisicionOpcion 
                                                                {...item} 
                                                                volumen={volumen} 
                                                                update={this.updateRequisicionOpcion}
                                                                aceptarOpcion={this.aceptarOpcion}
                                                                delete={()=>this.deleteOpcion(item._id, index)}
                                                            />
                                                        </List.Item>
                                                    )}
                                                />
                                            </Panel>
                                        </Collapse>
                                    </List.Item>
                                )}
                            />
                        </InfiniteScroll> : <Empty description={"Sin Requisisciones"} className="mb-3 mt-1"/> }

                    </Panel>
                </Collapse>

                <ModalProductoProveedor
                    visible={this.state.modal_visible}
                    onClose={()=>{
                        this.setState({modal_visible: false, requisicion_id: undefined, index_requisicion: undefined})
                    }}
                    requisicion_id={this.state.requisicion_id}
                    addOpcion={this.addOpcion}
                />
            </>
        )
    }
}
